import React from 'react';
import StartButton from './StartButton';
import type { InterestId } from '@/content/workflows';
import { cn } from '@/lib/utils';

interface ClosingCtaProps {
  eyebrow?: string;
  title: React.ReactNode;
  children?: React.ReactNode;
  footnote?: React.ReactNode;
  interest?: InterestId;
  /** Smaller headline for longer sentences. */
  compact?: boolean;
}

const ClosingCta = ({
  eyebrow = 'Free discovery call',
  title,
  children,
  footnote,
  interest,
  compact,
}: ClosingCtaProps) => (
  <section aria-labelledby="closing-title" className="relative overflow-hidden border-t border-rule">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-[radial-gradient(700px_320px_at_50%_50%,rgba(233,184,100,0.12),transparent_70%)]"
    />
    <div className="reveal relative mx-auto max-w-5xl px-4 py-28 text-center sm:px-6 md:py-36">
      <p className="eyebrow">{eyebrow}</p>
      <h2
        id="closing-title"
        className={cn(
          'mt-5 leading-[0.98]',
          compact ? 'text-[clamp(2.75rem,5.5vw,4.75rem)]' : 'text-[clamp(3.25rem,8vw,7rem)]',
        )}
      >
        {title}
      </h2>
      {children && <div className="mx-auto mt-6 max-w-[35rem] text-[1.06rem] text-mist">{children}</div>}
      <div className="mt-10">
        <StartButton size="lg" interest={interest} />
      </div>
      {footnote && <p className="mt-6 font-mono text-[0.68rem] uppercase tracking-[0.14em] text-mist">{footnote}</p>}
    </div>
  </section>
);

export default ClosingCta;
